import { __makeTemplateObject } from "tslib";
import styled, { css } from 'styled-components';
import { ThemeSelectors } from '../selectors/theme-selectors';
import { DisplayType } from './containers.types';
import { pxtoem, stripUnit } from '../utils/conversions';
import { dataAttrTestId } from '@at/formatter-utils/lib/data-attr-utils/data-attr-utils';
var minWidth = '640px';
// NOTE: This helper function isn't very nice, but it's more reliable than calc in the media query
var getMinWithPlusSpacing = function (theme) {
    return pxtoem("".concat(parseInt(stripUnit(ThemeSelectors.getMaxWidth(theme))) +
        parseInt(stripUnit(ThemeSelectors.getGroupFourSpacing(theme))), "px"));
};
var getVariantStyles = function (displayType) {
    switch (displayType) {
        case DisplayType.FIXED_WIDE:
            return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                margin: 0 auto ", ";\n                max-width: ", ";\n\n                @media (min-width: ", ") {\n                    margin: ", ";\n                }\n\n                @media (min-width: ", ") {\n                    margin: 0 auto ", ";\n                }\n            "], ["\n                margin: 0 auto ", ";\n                max-width: ", ";\n\n                @media (min-width: ", ") {\n                    margin: ", ";\n                }\n\n                @media (min-width: ", ") {\n                    margin: 0 auto ", ";\n                }\n            "])), function (_a) {
                var theme = _a.theme;
                return ThemeSelectors.getRelatedTwoSpacing(theme);
            }, function (_a) {
                var theme = _a.theme;
                return ThemeSelectors.getMaxWidth(theme);
            }, pxtoem(minWidth), function (_a) {
                var theme = _a.theme;
                return "0 ".concat(ThemeSelectors.getGroupFiveSpacing(theme), " ").concat(ThemeSelectors.getDistinctTwoSpacing(theme));
            }, function (_a) {
                var theme = _a.theme;
                return getMinWithPlusSpacing(theme);
            }, function (_a) {
                var theme = _a.theme;
                return ThemeSelectors.getDistinctTwoSpacing(theme);
            });
        case DisplayType.CONSTRAINED:
            return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                margin: ", ";\n                max-width: ", ";\n\n                @media (min-width: ", ") {\n                    margin: ", ";\n                }\n\n                @media (min-width: ", ") {\n                    margin: 0 auto ", ";\n                }\n            "], ["\n                margin: ", ";\n                max-width: ", ";\n\n                @media (min-width: ", ") {\n                    margin: ", ";\n                }\n\n                @media (min-width: ", ") {\n                    margin: 0 auto ", ";\n                }\n            "])), function (_a) {
                var theme = _a.theme;
                return "0 ".concat(ThemeSelectors.getGroupFourSpacing(theme), " ").concat(ThemeSelectors.getRelatedTwoSpacing(theme));
            }, function (_a) {
                var theme = _a.theme;
                return ThemeSelectors.getMaxWidth(theme);
            }, pxtoem(minWidth), function (_a) {
                var theme = _a.theme;
                return "0 ".concat(ThemeSelectors.getGroupFiveSpacing(theme), " ").concat(ThemeSelectors.getDistinctTwoSpacing(theme));
            }, function (_a) {
                var theme = _a.theme;
                return getMinWithPlusSpacing(theme);
            }, function (_a) {
                var theme = _a.theme;
                return ThemeSelectors.getDistinctTwoSpacing(theme);
            });
        default:
            return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                margin: 0 0 ", ";\n                max-width: initial;\n            "], ["\n                margin: 0 0 ", ";\n                max-width: initial;\n            "])), function (_a) {
                var theme = _a.theme;
                return ThemeSelectors.getRelatedTwoSpacing(theme);
            });
    }
};
var applyBackground = function (backgroundColour) {
    if (backgroundColour) {
        return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            background-color: ", ";\n        "], ["\n            background-color: ", ";\n        "])), function (_a) {
            var theme = _a.theme;
            return theme.color.bgSurface.soft;
        });
    }
};
var applyScrollable = function (isScrollable) {
    if (isScrollable) {
        return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n            overflow: auto visible;\n        "], ["\n            overflow: auto visible;\n        "])));
    }
};
export var ATDSStyledContainer = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: block;\n    position: relative;\n\n    ", ";\n    ", ";\n    ", ";\n"], ["\n    display: block;\n    position: relative;\n\n    ", ";\n    ", ";\n    ", ";\n"])), function (_a) {
    var displayType = _a.displayType;
    return getVariantStyles(displayType);
}, function (_a) {
    var isScrollable = _a.isScrollable;
    return applyScrollable(isScrollable);
}, function (_a) {
    var backgroundColour = _a.backgroundColour;
    return applyBackground(backgroundColour);
});
export var ATDSSectionTitle = styled.header.attrs(function () {
    var _a;
    return (_a = {}, _a[dataAttrTestId] = 'atds-section-title', _a);
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin: ", ";\n\n    @media (min-width: ", ") {\n        margin-bottom: ", ";\n        text-align: center;\n    }\n"], ["\n    margin: ", ";\n\n    @media (min-width: ", ") {\n        margin-bottom: ", ";\n        text-align: center;\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return "0 ".concat(ThemeSelectors.getGroupFourSpacing(theme), " ").concat(ThemeSelectors.getGroupFiveSpacing(theme));
}, pxtoem('640px'), function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getRelatedOneSpacing(theme);
});
export var ATDSSectionFooter = styled.footer.attrs(function () {
    var _a;
    return (_a = {}, _a[dataAttrTestId] = 'atds-section-footer', _a);
})(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-top: ", ";\n    text-align: center;\n\n    @media (min-width: ", ") {\n        margin-top: ", ";\n    }\n"], ["\n    margin-top: ", ";\n    text-align: center;\n\n    @media (min-width: ", ") {\n        margin-top: ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupFiveSpacing(theme);
}, function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getMaxWidth(theme);
}, function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getRelatedOneSpacing(theme);
});
export var flowContainer = function (showWhatWhen, thisMargin, thisGutter) {
    var strippedGutterSize = parseInt(stripUnit(thisGutter));
    var subtractionBase = parseInt(stripUnit(thisMargin)) * 2 + strippedGutterSize * 2;
    var totalElements = showWhatWhen.length + 1;
    var mediaQueries = '';
    showWhatWhen.forEach(function (_a) {
        var size = _a.size, numToShow = _a.numToShow;
        if (numToShow === 'locked' || typeof numToShow === 'string') {
            mediaQueries += "\n                @media (min-width: ".concat(size, ") {\n                    grid-auto-columns: auto;\n                    -ms-grid-columns: ms-grid-cols(").concat(totalElements, ");\n                    grid-template-columns: repeat(").concat(totalElements, ", 1fr);\n                }\n            ");
        }
        else {
            var percentageWidth = 100 / numToShow + '%';
            var subtraction = subtractionBase + (strippedGutterSize * (numToShow - 1)) / numToShow;
            mediaQueries += "\n                @media (min-width: ".concat(size, ") {\n                    grid-auto-columns: calc(").concat(percentageWidth, " - ").concat(subtraction, "px);\n                }\n            ");
        }
    });
    return css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n        display: grid;\n        grid-auto-columns: calc(100% - ", "px);\n        grid-auto-flow: column;\n        grid-gap: ", ";\n        max-width: ", ";\n        overflow-x: auto;\n        padding: 0 ", " ", ";\n        scroll-snap-type: x proximity;\n\n        ", "\n\n        @media (min-width: (", " + ", ")) {\n            margin: 0 auto;\n        }\n    "], ["\n        display: grid;\n        grid-auto-columns: calc(100% - ", "px);\n        grid-auto-flow: column;\n        grid-gap: ", ";\n        max-width: ", ";\n        overflow-x: auto;\n        padding: 0 ", " ", ";\n        scroll-snap-type: x proximity;\n\n        ", "\n\n        @media (min-width: (", " + ", ")) {\n            margin: 0 auto;\n        }\n    "])), subtractionBase, thisGutter, function (_a) {
        var theme = _a.theme;
        return ThemeSelectors.getMaxWidth(theme);
    }, thisMargin, function (_a) {
        var theme = _a.theme;
        return ThemeSelectors.getGroupFourSpacing(theme);
    }, mediaQueries, function (_a) {
        var theme = _a.theme;
        return ThemeSelectors.getMaxWidth(theme);
    }, function (_a) {
        var theme = _a.theme;
        return ThemeSelectors.getRelatedOneSpacing(theme);
    });
};
/**
 * Removes quotes from a string if present.
 * @param {string} str - The string possibly wrapped in quotes.
 * @returns {string} - The string without quotes.
 */
var unquote = function (str) {
    // Remove leading and trailing quotes if present
    return str.replace(/^['"](.*)['"]$/, '$1');
};
/**
 * Sets the number of columns for a CSS grid layout based on the provided number of columns.
 * @param {number} columns - Number of columns for the grid layout.
 * @returns {string} - CSS grid column specification.
 */
export var msGridCols = function (columns) {
    var string = "(1fr)[".concat(columns, "]");
    return unquote(string);
};
/**
 * Updates the CSS grid layout based on the provided configuration.
 * @param {number} columns - Number of columns for the grid layout.
 * @param {number} gutter - Gutter size for the grid layout.
 * @param {number} [margin=4] - Margin size for the grid layout.
 * @param {boolean} [wrap=false] - Whether to wrap grid items.
 */
export var gridUpdate = function (columns, gutter, margin, wrap) {
    if (margin === void 0) { margin = 4; }
    if (wrap === void 0) { wrap = false; }
    var width = wrap ? "".concat((100 / columns) * 1, "vw") : null;
    var minWidth = wrap ? "calc(".concat(width, " - ").concat(margin + 4, "px)") : null;
    var styles = {
        'grid-template-columns': wrap ? null : "repeat(".concat(columns, ", 1fr)"),
        '-ms-grid-columns': wrap ? null : msGridCols(columns),
        gap: gutter ? "atds-spacing(group, ".concat(gutter, ")") : null,
        'min-width': wrap ? minWidth : null,
    };
    return styles;
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
